/* oxlint-disable react/no-danger */

import { MortgageAnnotations } from '@cian/adfox-templates';

import cn from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';

import { Link } from '../link/link';
import { FILTERS_BLOCK_HEIGHT } from '../adfox/constants';
import { setHasMortgageDisclaimer } from '../../actions/adBanner';

import styles from './styles.css';

export interface IMediaBannerProps {
  containerId: string;
  hasNewPlacement: boolean;
  url: string;
  logoImageUrl: string;
  substrateNotNeeded: boolean;
  sanitizedName: string | undefined;
  sanitizedActionText: string | undefined;
  sanitizedPhone: string | undefined;
  buttonText: string | undefined;
  sanitizedInfo: string | undefined;
  label: string | undefined;
  mortgageWarning: string | undefined;
  mortgageTermsWarning: string | undefined;
  isRedesignEnabled?: boolean;
}

export const MediaBanner: React.FC<IMediaBannerProps> = ({
  containerId,
  hasNewPlacement,
  url,
  logoImageUrl,
  substrateNotNeeded,
  sanitizedName,
  sanitizedActionText,
  sanitizedPhone,
  buttonText = 'Узнать цены',
  sanitizedInfo,
  mortgageWarning,
  mortgageTermsWarning,
  isRedesignEnabled,
}) => {
  const dispatch = useDispatch();
  const withMortgageAnnotations = !!(mortgageWarning || mortgageTermsWarning);

  React.useEffect(() => {
    dispatch(setHasMortgageDisclaimer(withMortgageAnnotations));

    return () => {
      dispatch(setHasMortgageDisclaimer(false));
    };
  }, [dispatch, withMortgageAnnotations]);

  return (
    <div
      id={containerId}
      className={cn(
        styles['c-filters-brand'],
        hasNewPlacement && styles['c-filters-brand--new-placement'],
        isRedesignEnabled && styles['c-filters-brand--redesign'],
      )}
    >
      <div
        className={cn(styles['c-filters-brand-info'], isRedesignEnabled && styles['c-filters-brand-info--redesign'])}
      >
        <a
          className={styles['c-filters-brand-flag']}
          href={url}
          target="_blank"
          role="img"
          rel="noopener noreferrer"
          dangerouslySetInnerHTML={sanitizedActionText ? { __html: sanitizedActionText } : undefined}
        />
        <a
          className={substrateNotNeeded ? styles['c-filters-brand-logo'] : styles['c-filters-brand-logo-bg']}
          href={url}
          rel="noopener noreferrer"
          role="img"
          target="_blank"
        >
          <img src={logoImageUrl} alt="logo" />
        </a>
        <div className={styles['c-filters-brand-left']}>
          {(!!sanitizedName || !!sanitizedInfo) && (
            <a
              className={styles['c-filters-brand-link']}
              href={url}
              rel="noopener noreferrer"
              role="button"
              target="_blank"
            >
              {!!sanitizedName && (
                <h3 className={styles['c-filters-brand-title']} dangerouslySetInnerHTML={{ __html: sanitizedName }} />
              )}
              {!!sanitizedInfo && (
                <p className={styles['c-filters-brand-text']} dangerouslySetInnerHTML={{ __html: sanitizedInfo }} />
              )}
            </a>
          )}
          <div className={styles['c-filters-brand-prices']}>
            <Link href={url} className={styles['c-filters-brand-button']} rel="noopener noreferrer" target="_blank">
              {buttonText}
            </Link>
            {!!sanitizedPhone && (
              <span className={styles['c-filters-brand-tel']} dangerouslySetInnerHTML={{ __html: sanitizedPhone }} />
            )}
          </div>
        </div>
      </div>
      {withMortgageAnnotations && (
        <div
          className={cn(styles['mortgage-disclaimer'], isRedesignEnabled && styles['mortgage-disclaimer--redesign'])}
        >
          <MortgageAnnotations
            height={FILTERS_BLOCK_HEIGHT}
            mortgageWarning={mortgageWarning}
            mortgageTermsWarning={mortgageTermsWarning}
          />
        </div>
      )}
    </div>
  );
};
